import { call, ForkEffect, takeEvery } from 'redux-saga/effects'

import { PAPER_ELEMENT_TYPE } from '../../../shared/constants/drawable-types'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Workspace } from '../../lib/toolBoxes/2D'
import { setHighlightsVisibility } from '../../slices/tools'

export function* handleToggleHighlightsVisibility({
    payload: isHighlightsVisible,
}: ReturnType<typeof setHighlightsVisibility>) {
    const paperManager: PaperManager | null = yield call(managers.get2DManager)

    if (!paperManager) return

    const workspaceTool: Workspace = yield call(paperManager.getTool, Workspace.NAME)

    const highlightPaths: paper.Item[] = yield call(
        workspaceTool.getItemsWithCriteria,
        'data',
        (data) => data.type === PAPER_ELEMENT_TYPE.HIGHLIGHT
    )

    highlightPaths.forEach((highlight) => {
        highlight.visible = isHighlightsVisible
    })
}

export function* watchForToggleHighlightsVisibility(): Generator<ForkEffect<never>, void, unknown> {
    yield takeEvery(setHighlightsVisibility.type, handleToggleHighlightsVisibility)
}
